var React = require('react');

function ArrowLongDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.9167 4.16675L22.9167 37.8542L17.5209 32.4792L14.5834 35.4167L25 45.8334L35.4167 35.4167L32.4792 32.4792L27.0834 37.8542L27.0834 4.16675L22.9167 4.16675Z","fill":"#1F1C2D"}));
}

ArrowLongDown.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = ArrowLongDown;

ArrowLongDown.default = ArrowLongDown;
